import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-factory',
  templateUrl: './factory.component.html',
  styleUrls: ['./factory.component.scss', './factory.component.media.scss']
})
export class FactoryComponent implements OnInit {
  techArr = [
    {
      src: './assets/zhengshu-1.jpg',
    },
    {
      src: './assets/zhengshu-2.jpg',
    }
  ];
  constructor() { }

  ngOnInit() {
  }

}
